import type { DealItemWithVersions } from '@/lib/graphql/generated/graphql';
import type { Row } from '@tanstack/react-table';
import { atom } from 'jotai';

export const filteredFlatRowsState = atom<Row<DealItemWithVersions>[]>([]);

export const filteredRowsCountState = atom((get) => {
  const flatRows = get(filteredFlatRowsState);
  return flatRows.filter((row) => row.subRows?.length === 0).length;
});
